import "@mantine/core/styles.css";

import {
  AppShell,
  colorsTuple,
  Container,
  createTheme,
  Flex,
  MantineProvider,
  Space,
  virtualColor,
} from "@mantine/core";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { Footer } from "./Footer";
import { Header } from "./Header";

const elem = document.getElementById("root")!;

const theme = createTheme({
  fontFamily: "Poppins",
  colors: {
    "solidstudio-blue__light": colorsTuple("#002AEA"),
    "solidstudio-blue__dark": colorsTuple("#6698FF"),
    "solidstudio-blue": virtualColor({
      name: "solidstudio-blue",
      light: "solidstudio-blue__light",
      dark: "solidstudio-blue__dark",
    }),
  },
});

const app = (
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="auto">
      <AppShell>
        <AppShell.Main style={{ display: "flex", flexDirection: "column" }}>
          <Container size="sm">
            <Space h="40px" />
            <Header />
            <Space h="40px" />
            <App />
          </Container>
          <Flex direction="column" flex={1} />
          <Space h="80px" />
          <Footer />
        </AppShell.Main>
      </AppShell>
    </MantineProvider>
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
